import styled, { css } from 'styled-components';

import { Config as ScrollbarConfig } from '../../theme/Scrollbar';
import { rem, toRemString } from '../../utils';

const HEADER_SIZE = 35;

/**
 * Editor scrollbar has 5px width
 * sidebar 320px
 * sidebar content 288px
 * sidebar padding left 16px
 * sidebar padding right 11px
 * scrollbar margin is 5px
 */

/**
 * Fluer-Editor scrollbar has 5px width
 * sidebar 280px
 * sidebar content 264px
 * sidebar padding left 8px
 * sidebar padding right 5px
 * scrollbar margin is 3px
 */

/**
 * Padding left|right are hardcoded because of the scrollbar
 */

export const StyledWrapper = styled.div<{
  $locked: boolean;
  $hasTitle: boolean;
}>(
  ({ theme, $locked, $hasTitle }) => css`
    position: relative;
    display: flex;
    flex-flow: column;

    width: ${rem(
      ScrollbarConfig.ThinWidth +
        theme.Components.ToolBar.contentContainer -
        (theme.Components.ToolBar.sidePadding - theme.Scrollbar.Config.NormalWidth) / 2
    )};
    padding: ${toRemString([
      0,
      0,
      theme.Components.ToolBar.blockPadding,
      theme.Components.ToolBar.sidePadding,
    ])};

    margin-top: ${({ theme }) => rem(theme.Components.ToolBar.blockPadding)};

    height: ${$hasTitle ? `calc(100% - ${HEADER_SIZE}px)` : '100%'};
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: ${$locked ? 'clip' : 'auto'};

    background-color: ${theme.Components.Panel.Background};

    ${theme.Scrollbar.Default}
  `
);

export const StyledHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    position: relative;

    height: ${rem(HEADER_SIZE)};

    padding: ${toRemString([
      theme.Spacing.Size.XSmall,
      theme.Spacing.Size.XSmall,
      theme.Spacing.Size.XSmall - theme.Border.Size.Small,
      theme.Spacing.Size.XSmall,
    ])};

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: ${rem(theme.Border.Size.Small)};
      border-radius: ${rem(20)};
      background: ${theme.Color.Neutrals.Border};
    }
  `
);

export const StyledHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  width: 100%;
`;

export const StyledBackButton = styled.a<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const StyledContent = styled.div<{
  $hasTitle: boolean;
}>(
  ({ theme, $hasTitle }) => css`
    display: flex;
    flex: 1 0 auto;
    flex-flow: column;
    box-sizing: border-box;

    width: ${rem(
      theme.Components.ToolBar.contentContainer -
        theme.Components.ToolBar.sidePadding -
        theme.Scrollbar.Config.NormalWidth -
        (theme.Components.ToolBar.sidePadding - theme.Scrollbar.Config.NormalWidth) / 2
    )};
    min-height: ${$hasTitle ? `calc(100% - ${HEADER_SIZE}px)` : '100%'};

    padding: ${toRemString([
      0,
      (theme.Components.ToolBar.sidePadding - theme.Scrollbar.Config.NormalWidth) / 2,
      theme.Spacing.Size.XSmall,
      0,
    ])};

    background-color: ${theme.Components.Panel.Background};
  `
);
